<template>
  <video
    class="video-player"
    ref="videoPlayer"
    v-bind:muted="muted"
    playsinline
    preload="yes"
    autoplay
  ></video>
</template>

<script>
// eslint-disable-next-line import/extensions
import Hls from 'hls.js';

export default {
  name: 'VideoPlayer',

  props: {
    url: {
      type: String,
      required: true,
    },

    muted: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      hls: null,
    };
  },

  beforeDestroy() {
    this.$refs.videoPlayer.removeEventListener('pause', this.videoPaused);

    if (this.hls) {
      this.hls.detachMedia();
      this.hls.destroy();
    }
  },

  mounted() {
    try {
      if (Hls.isSupported()) {
        this.hls = new Hls();
        this.hls.loadSource(this.url);
        this.hls.attachMedia(this.$refs.videoPlayer);

        this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
          this.$refs.videoPlayer.play();
        });
      } else if (this.canPlayUrl()) {
        this.$refs.videoPlayer.src = this.url;
        this.$refs.videoPlayer.addEventListener(
          'loadmediadata',
          () => {
            this.$refs.videoPlayer.play();
          },
        );
      }
    } catch (e) {
      console.error(e);
    }

    this.$refs.videoPlayer.addEventListener('pause', this.videoPaused);
  },

  methods: {
    canPlayUrl() {
      return this.$refs.videoPlayer
        .canPlayType('application/vnd.apple.mpegurl');
    },

    videoPaused(evt) {
      if (evt.type !== 'pause') return;

      this.$emit('videoStop');
    },

    play() {
      this.$refs.videoPlayer.play();
    },
  },
};
</script>

<style>

</style>
